const AI_IMAGE_FILE = '/luke.png';

const SENTIMENT = {
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
  NEUTRAL: 'neutral',
};

export { AI_IMAGE_FILE, SENTIMENT };
